module.exports = __webpack_public_path__ + "img/2.05.thmb.xs.0a796622.jpg";